var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uim-anchor"},[_c('ul',{staticClass:"uim-anchor-inner"},[_vm._t("uim-anchor-inner")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }